module.exports = __webpack_public_path__ + "img/AF.e287a0c3.svg";